/* MixLight – lead-uri din formularele .ml-form (snippets/ml-lead-form.liquid).
 * Preluat din tema „MixLight Lead Gen - Horizon (DEV)” (assets/lead-form.js):
 *  - la trimitere, lead-ul pleacă și în Odoo (fire-and-forget, keepalive), fără să blocheze
 *    sau să anuleze trimiterea standard Shopify (e-mailul către magazin);
 *  - după o trimitere reușită, vizitatorul ajunge pe pagina de mulțumire (conversia Google Ads din GTM).
 * Setările vin din window.mlLeads (snippets/ml-tracking.liquid).
 */
(function () {
  var cfg = window.mlLeads = window.mlLeads || {};

  // câmpurile formularului → numele așteptate de webhook-ul Odoo (aceleași ca în tema lui Dani)
  var FIELDS = {
    'contact[nume]': 'full_name',
    'contact[companie]': 'company',
    'contact[email]': 'email',
    'contact[telefon]': 'phone',
    'contact[mesaj]': 'message'
  };

  // valoarea din contact[sursa] → sursa lead-ului în Odoo (aceleași denumiri ca în tema lui Dani)
  var SOURCES = {
    homepage: 'Shopify - Cere oferta (homepage)',
    produs: 'Shopify - Cere oferta',
    contact: 'Shopify - Contact',
    b2b: 'Shopify - B2B'
  };

  function val(form, name) {
    var el = form.elements[name];
    return el && el.value ? String(el.value).trim() : '';
  }

  function buildPayload(form) {
    var payload = { shopify_key: cfg.odooKey || '' };

    Object.keys(FIELDS).forEach(function (name) {
      if (form.elements[name]) payload[FIELDS[name]] = val(form, name);
    });

    // O bifă are mereu atributul value, deci raportăm starea ei, nu valoarea.
    var consent = form.elements['contact[acord_date]'];
    if (consent) payload.consent = consent.checked ? 'da' : 'nu';

    // B2B: CUI-ul și tipul de partener nu au câmp propriu în Odoo, așa că le punem în mesaj.
    var extra = [];
    if (val(form, 'contact[cui]')) extra.push('CUI: ' + val(form, 'contact[cui]'));
    if (val(form, 'contact[tip_partener]')) extra.push('Tip partener: ' + val(form, 'contact[tip_partener]'));
    if (extra.length) payload.message = [payload.message || '', extra.join('\n')].filter(Boolean).join('\n\n');

    // Produsul: din formularul rapid de pe pagina de produs (include pasul de pixel ales) sau din pagină.
    var item = val(form, 'contact[produs]');
    if (item || cfg.productTitle) {
      payload.product_name = item || cfg.productTitle;
      payload.product_sku = cfg.productSku || '';
    }
    payload.product_url = window.location.origin + window.location.pathname;

    var sursa = val(form, 'contact[sursa]');
    payload.source = SOURCES[sursa] || (sursa ? 'Shopify - ' + sursa : 'Shopify - Cere oferta');

    return payload;
  }

  function sendToOdoo(form) {
    if (!cfg.odooUrl || !cfg.odooKey) return;
    var qs = new URLSearchParams(buildPayload(form)).toString();
    try {
      fetch(cfg.odooUrl + '?' + qs, { method: 'POST', mode: 'no-cors', keepalive: true }).catch(function () {});
    } catch (error) {
      // Nu interferăm niciodată cu trimiterea Shopify.
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('ml-form')) return;
    if (cfg.designMode || form.__mlLeadSent) return;
    form.__mlLeadSent = true;
    sendToOdoo(form);
  });

  // După o trimitere reușită, Shopify reîncarcă pagina cu mesajul de succes (.ml-msg-ok).
  function redirectAfterPost() {
    if (!cfg.thankyouUrl || cfg.designMode) return;
    if (!document.querySelector('form.ml-form .ml-msg-ok')) return;
    if (window.location.pathname === cfg.thankyouUrl) return;
    setTimeout(function () {
      window.location.assign(cfg.thankyouUrl);
    }, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', redirectAfterPost);
  } else {
    redirectAfterPost();
  }

  // pentru verificare din consolă, fără să trimită nimic
  cfg.preview = function (form) { return buildPayload(form); };
})();
